module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Clock-7fb501a3542bb240f6e0ee25132ceec8f4de8694ccce9013e7b094dd3af888c0.svg";